/**
 * Remove explicit undefined keys. Equivalent to the original object when
 * accessing, but won't overwrite when used as a spread
 */
export const withoutUndefinedValues = <T extends object>(x: T): T =>
    Object.fromEntries(
        Object.entries(x).filter(([, v]) => v !== undefined)
    ) as T
